import React, { useState } from 'react'
import ToogleButton from '../../components/ToogleButton/ToogleButton'
import { MuiOtpInput } from 'mui-one-time-password-input'
import { TextFieldProps } from '@mui/material';
// import { sendForgotPasswordOtpAddress } from '../../services/authenticationService';
import ReverseTimer from '../../components/ReverseTimer/ReverseTimer';
import { MAX_TIME } from './otpVerificationUtils';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';


const otpTextFieldsProps: TextFieldProps = {
    style: {
        background: "white",
        borderRadius: "4px",
    },
    inputProps: {
        style: {
            padding: "5px 0",
            color: "#909090",
            fontSize: "20px",
            fontWeight: 800,
        },
    },
};


interface OTPVerificationProps {
    resendOtp: () => Promise<void>;
    onSuccess: (messaage:string , response?:any) => void;
    onFailure: (message: string , response?:any) => void;
    verifyOTP: (otp:string) => Promise<{ result: boolean, message: string  , response?:any}>;
    OtpVerficationHeader?: React.ReactElement;
    loginUIConfig?:any;
    otpLength?: number;
}




function OTPVerification(props: OTPVerificationProps) {
    const CUR_COMPONENT = "ValidateOtp"
    const { translate } = usePortalTranslation();
    const { resendOtp, onSuccess, onFailure, verifyOTP,OtpVerficationHeader } = props;
    const [otp, setOtp] = useState("");
    const [resendOtpState, setresendOtpState] = useState(false);
    const [Timeleft, setTimeleft] = useState(MAX_TIME);
    const [toggleState, setToggleState] = useState(false);

    const updateOtp = (newValue: string) => {
        setOtp(newValue);
    };

    const handleResendOtp = async (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault()
        await resendOtp();
        setTimeleft(MAX_TIME)
        setresendOtpState(false);
    }

    const onTimerEnd = () => {
        setresendOtpState(true);
        setTimeleft(() => 0);
    };

    function renderTimeleft() {
        if (Timeleft > 0) {
            return (
                <ReverseTimer
                    loginUIConfig={props?.loginUIConfig}
                    className="verify-OTP-Timer"
                    initialTime={Timeleft}
                    onTimerZero={onTimerEnd}
                />
            );
        } else {
            return <></>;
        }
    }


    const handleVerification = async () => {
        setToggleState(!toggleState);
        const { result, message , response} = await verifyOTP(otp);
        if (result) {
            onSuccess(message,response);
        } else {
            onFailure(message,response);
        }
        setToggleState(false);
    };


    return (
        <form className="loginInputs">
            {
                OtpVerficationHeader ? 
                    OtpVerficationHeader  : 
                    <div className="otp-label"> {translate(TranslationEnum.validate_otp,"OTP sent ")}</div>
            }
           
            <MuiOtpInput
                TextFieldsProps={otpTextFieldsProps}
                className="otp-input"
                id="otp"
                value={otp}
                length={props.otpLength ?? 6}
                onChange={updateOtp}
            />
            <button
                className={resendOtpState ? "resend-otp-link" : "disableResend"}
                onClick={handleResendOtp}
                disabled={!resendOtpState}
                style={props?.loginUIConfig ? { color:"#ED1229" } : {}}
            >
                {resendOtpState ? (
                    translate(TranslationEnum.validate_otp,"Resend OTP")
                ) : (
                    <span style={props?.loginUIConfig ? { color:"#ED1229" } : {}}>
                        {translate(TranslationEnum.validate_otp,"Didn't receive OTP ? Resend in")}{"("}
                        {renderTimeleft()}
                        {")"}
                    </span>
                )}
            </button>
            <ToogleButton
                loginUIConfig={props?.loginUIConfig}
                status1="SUBMIT"
                status2="SUBMITTING"
                handleChange={handleVerification}
                updateToggleState={toggleState}
            />
        </form>
    )
}

export default OTPVerification;